import React from 'react';
import { Select, Form } from 'antd';
import filterConnect from '../../../../../../../common/hoc/filterConnect';
const Option = Select.Option;

// todo onChange={onChangeRegionOrder}  filter.region
const Regions = ({ form, regions }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Регион подачи:">
      {getFieldDecorator('regions')(
        <Select
          style={{ width: '100%' }}
          className="ui-select"
          placeholder="Выберите регион"
          allowClear={true}
          mode="multiple"
          dropdownClassName="ui-select__dropdown-multiple"
          showArrow={true}
          getPopupContainer={trigger => trigger.parentNode}
        >
          {regions &&
            regions.map(region => (
              <Option key={region.regionId}>{region.region}</Option>
            ))}
        </Select>
      )}
    </Form.Item>
  );
};

export default filterConnect(Regions, ['regions']);
